<template lang="html">
  <div class="goods-info-content">
    <el-form-item
      label="货物："
      :prop="`${cardKey}.goods.${itemIndex}.goodsCategoryid`"
      class="goods-item"
    >
      <el-select
        filterable
        v-model="ruleForm[cardKey].goods[itemIndex].goodsCategoryid"
        :placeholder="getInputText('goodsCategoryid')"
        @focus="e => selectFocus(cardKey, itemIndex)"
        @change="val => selectChange(val, cardKey, itemIndex)"
      >
        <el-option
          v-for="item in goodsArr"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item
      label="重量："
      class="form-item-wrap-middle"
      :prop="`${cardKey}.goods.${itemIndex}.goodsWeight`"
    >
      <el-input
        type="number"
        v-model="ruleForm[cardKey].goods[itemIndex].goodsWeight"
        :placeholder="getInputText('goodsWeight')"
      ></el-input>
    </el-form-item>
    <el-form-item
      label="件数："
      :prop="`${cardKey}.goods.${itemIndex}.goodsNumber`"
    >
      <el-input
        type="number"
        v-model="ruleForm[cardKey].goods[itemIndex].goodsNumber"
        :placeholder="getInputText('goodsNumber')"
      ></el-input>
    </el-form-item>
  </div>
</template>

<script>
import { getInputText } from "@/views/personal/deliver/components/handlingWrapper/config";
export default {
  props: {
    cardKey: {
      type: Number,
      default: 0
    },
    itemIndex: {
      type: Number,
      default: 0
    },
    ruleForm: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      goodsArr: []
    };
  },
  computed: {},
  created() {
    this.getGoodsNo();
  },
  methods: {
    getInputText,
    selectFocus(bigIndex, i) {
      let savedGoodsArr = JSON.parse(sessionStorage.getItem("goodsArr"));
      let tempGoodsArr = this.ruleForm[bigIndex].goods
        .filter((item, index) => index !== i)
        .map(item => item.goodsCategoryid);
      this.goodsArr = savedGoodsArr.filter(
        item => !tempGoodsArr.includes(item.value)
      );
    },
    selectChange(val, cardKey, itemIndex) {
      this.ruleForm[cardKey].goods[itemIndex].goodsName = this.goodsArr.find(
        item => item.value === val
      ).label;
    },
    async getGoodsNo() {
      let savedGoodsArr = JSON.parse(sessionStorage.getItem("goodsArr"));
      if (savedGoodsArr) {
        this.goodsArr = savedGoodsArr;
      } else {
        let {
          data: { list }
        } = await this.$http.get("/shipper/goods/category");
        let tempArr = list.map(({ label, name }) => ({
          label: name,
          value: label
        }));
        this.goodsArr = tempArr;
        sessionStorage.setItem("goodsArr", JSON.stringify(tempArr));
      }
    }
  },
  watch: {},
  components: {}
};
</script>

<style lang="scss" scoped>
.goods-info-content {
  display: flex;
  .el-form-item {
    flex: 1;
    display: flex;
    .el-form-item__content {
      flex: 1;
    }
  }
  .goods-item {
    .el-input__inner {
      height: 40px !important;
    }
  }
  .form-item-wrap-middle {
    padding: 0 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/personal/deliver/components/handlingWrapper/components/goodsCard/index.vue